import {cn} from '@/helpers/shadcn/utils'
import {ComponentProps} from 'react'

type HtmlPreviewProps = ComponentProps<'iframe'> & {
  html?: string | null
}

/**
 * Renders untrusted HTML (e.g. an email template body) in a sandboxed iframe.
 * The empty `sandbox` attribute disables script execution, form submission and
 * top-level navigation, since no HTML sanitizer is available in this project.
 */
export const HtmlPreview = ({html, className, title = 'HTML preview', ...props}: HtmlPreviewProps) => {
  return (
    <iframe
      data-testid="html-preview-frame"
      srcDoc={html ?? ''}
      sandbox=""
      title={title}
      className={cn('h-96 w-full rounded-lg border border-border-gray bg-white', className)}
      {...props}
    />
  )
}
